import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  FormElement,
  SELECT_VARIANT_WITH_CHECKBOX,
  Select,
} from 'mailup-web-components'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { modalUnsubscribeChangeListsCallback } from 'Pages/RecipientsList/recoil/callbacks/modals'
import {
  modalUnsubscribeRecipientListsState,
  modalUnsubscribeState,
} from 'Pages/RecipientsList/recoil/state/modals'

import InputSelectAllLists from './InputSelectAllLists'

const InputLists: FC = () => {
  const intl = useIntl()

  const { lists, allLists } = useRecoilValue(modalUnsubscribeState)

  const items = useRecoilValue(modalUnsubscribeRecipientListsState)

  const handleChangeLists = useRecoilCallback(
    modalUnsubscribeChangeListsCallback,
    [],
  )

  const notValid = lists.length === 0

  const feedback = notValid
    ? intl.formatMessage({
        id: 'Load.MailupCommon.Required',
      })
    : undefined

  const feedbackVariant = notValid ? 'error' : undefined

  if (items.length <= 1) {
    return null
  }

  return (
    <FormElement
      required
      label={intl.formatMessage({
        id: 'Load.RecipientsList.ModalUnsubscribeChooseLists',
      })}
      LabelRightComponent={InputSelectAllLists}
      feedback={feedback}
      feedbackVariant={feedbackVariant}
    >
      <Select
        multiple
        variant={SELECT_VARIANT_WITH_CHECKBOX}
        value={lists}
        options={items}
        onChange={handleChangeLists}
        data-mu-test="input-lists"
        disabled={allLists}
        placeholder={intl.formatMessage({
          id: 'Load.Common.PlaceHolderSelectMultipleList',
        })}
        error={notValid}
      />
    </FormElement>
  )
}

export default InputLists
